/* istanbul ignore file */
import { SET_ACCOUNT_TRANSACTIONS } from './actionTypes'

export const setAccountTransactions = items => {
  return {
    type: SET_ACCOUNT_TRANSACTIONS,
    items
  }
}
